import { shortLabel } from "@/lib/scoring";

// Compact live stats for the player being scored; updates after every tap.
export default function LivePanel({ cur, outcomes, discipline }) {
  if (!cur) return null;
  const n = cur.reps || 0;
  const c = (k) => cur.counts?.[k] || 0;
  const pct = (x) => (n ? Math.round((1000 * x) / n) / 10 : 0);
  const strikes = outcomes.filter((o) => o.key.startsWith("strike")).reduce((a, o) => a + c(o.key), 0);
  return (
    <div data-testid="live-panel" className="rounded-2xl border-2 border-[#0B0F19] bg-white p-4">
      <p className="text-[11px] font-bold uppercase tracking-wider text-slate-400">Now scoring</p>
      <p data-testid="live-name" className="text-lg font-extrabold text-[#0B0F19] break-words">{cur.name}</p>
      <div className="mt-3 grid grid-cols-3 gap-2 text-center">
        {[["Total", cur.points, "live-total"], ["Avg", cur.avg, "live-avg"], [discipline === "pitching" ? "Pitches" : "Swings", n, "live-attempts"]].map(([l, v, t]) => (
          <div key={l} className="rounded-xl bg-slate-50 py-2"><p className="text-[10px] font-bold uppercase text-slate-400">{l}</p><p data-testid={t} className="text-xl font-extrabold tabular-nums text-[#0B0F19]">{v}</p></div>
        ))}
      </div>
      <div className="mt-3 grid grid-cols-2 lg:grid-cols-1 gap-x-4">
        {outcomes.map((o) => (
          <p key={o.key} className="flex justify-between gap-3 py-1 text-sm border-b border-slate-100"><span className="text-slate-600 min-w-0">{shortLabel(o)}</span><b data-testid={`live-count-${o.key}`} className="tabular-nums text-[#0B0F19]">{c(o.key)}</b></p>
        ))}
      </div>
      {discipline === "pitching" && (
        <div className="mt-3 grid grid-cols-2 gap-2 text-center">
          <div className="rounded-xl bg-[#2563EB]/10 py-2"><p className="text-[10px] font-bold uppercase text-[#2563EB]">Strike %</p><p data-testid="live-strike-pct" className="text-lg font-extrabold text-[#0B0F19]">{pct(strikes)}%</p></div>
          <div className="rounded-xl bg-[#2563EB]/10 py-2"><p className="text-[10px] font-bold uppercase text-[#2563EB]">Located %</p><p data-testid="live-located-pct" className="text-lg font-extrabold text-[#0B0F19]">{pct(c("strike_located"))}%</p></div>
        </div>
      )}
    </div>
  );
}
